import {Drawer, Icon, IconButton} from "@material-ui/core";
import React, {FC, useMemo} from "react";
import styles from './TablePaymentHeader.module.scss';
import TableBarOutlinedIcon from '@mui/icons-material/TableBarOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import {useTablePayment} from "../../../context/tablePayment/TablePaymentContext";
import Menu from "../../private/privateLayout/menu/Menu";
import {DialogManager} from "../../../components/dialog/DialogManager";
import {useMenu} from "../../../services/hooks/useMenu";
import { useUi } from "context/ui/UIContext";
import { useAuth } from "context/auth/AuthContext";


export const TablePaymentHeader: FC = () => {
    const {initialLettersByUsers, sharedExtracts, openMenu, setOpenMenu} = useTablePayment();
    const extraCount = useMemo(() => initialLettersByUsers.length > 3
        ? initialLettersByUsers.length - 2 : 0, [initialLettersByUsers]);
    const { logout, isAuth, openModalLogin } = useAuth();
    const { isIframe } = useUi();

    const {
        dialogLogoutOpen,
        dialogCloseOpen,
        dialogDeleteAccountOpen,
        isDeleting,
        setDialogLogoutOpen,
        setDialogCloseOpen,
        setDialogDeleteAccountOpen,
        onClickLogin,
        onClickLogout,
        onClickConfirmBack,
        onClickDeleteAccount,
        handleDeleteAccount,
    } = useMenu({ logout, isIframe, openModalLogin });

    return (<>
            <div className={styles.headerContainer}>
                <header className={styles.headerContent}>
                    <div className={styles.tableContainer}>
                        <TableBarOutlinedIcon/>
                        <p>{sharedExtracts?.command.tableIdentifier ?? ''}</p>
                        <hr/>
                        <PersonOutlineOutlinedIcon/>
                        <div className={styles.usersListContainer}>
                            {initialLettersByUsers.map((ini, idx) => (<div key={idx} className={styles.userInitial}>
                                    {ini}
                                </div>))}
                            {extraCount > 0 && (<div className={styles.userInitial}>{extraCount}</div>)}
                        </div>
                    </div>
                    <IconButton onClick={() => setOpenMenu(true)} style={{color: 'white'}}><Icon
                        className="icon">menu</Icon></IconButton>
                </header>
            </div>
            <Drawer anchor="right" open={openMenu} style={{minWidth: 250}} onClose={() => setOpenMenu(false)}>
                <Menu
                    onClickOut={isAuth ? () => setDialogLogoutOpen(true) : undefined}
                    onClickLogin={!isAuth ? onClickLogin : undefined}
                    onClickDeleteAccount={isAuth ? onClickDeleteAccount : undefined}
                />
            </Drawer>

            <DialogManager
                dialogLogoutOpen={dialogLogoutOpen}
                setDialogLogoutOpen={setDialogLogoutOpen}
                onLogout={onClickLogout}
                dialogCloseOpen={dialogCloseOpen}
                setDialogCloseOpen={setDialogCloseOpen}
                onConfirmBack={onClickConfirmBack}
                dialogDeleteAccountOpen={dialogDeleteAccountOpen}
                setDialogDeleteAccountOpen={setDialogDeleteAccountOpen}
                onDeleteAccount={handleDeleteAccount}
                isDeleting={isDeleting}
            />
        </>)
}